import { FC, ReactNode } from 'react';

import { CodeSample, IconAdd } from '@getstream/ui-library/build';

import styles from './Modal.module.css';

export type Props = {
  children: ReactNode | undefined;
  onClose: () => void;
  title: string;
};
export const Modal: FC<Props> = ({ children, onClose, title }) => {
  return (
    <div className={styles.getStartedModal}>
      <div className={styles.getStartedModalContent}>
        <header className={styles.getStartedModalTitle}>
          <span>{title}</span>
          <button onClick={onClose}>
            <IconAdd className={styles.getStartedModalIcon} />
          </button>
        </header>
        <div className={styles.getStartedModalBody}>
          <CodeSample minHeight={false} language="javascript" copy>
            {children}
          </CodeSample>
        </div>
      </div>
    </div>
  );
};
